var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Autocomplete, Box, CircularProgress, MenuItem, TextField as MuiTextField, } from '@mui/material';
import { dynamicFieldSx } from '../../FormComponents/dynamicForm';
import { LOOKUP_LOADER_SX, LOOKUP_MENU_ITEM_SX, LOOKUP_OPTIONAL_MARK_SX, LOOKUP_REQUIRED_MARK_SX, LOOKUP_SELECT_PROPS, } from './start_application_styles';
var LOADING_HELPER_TEXT = 'Loading…';
var NO_OPTIONS_HELPER_TEXT = 'No options available yet';
var SEARCH_PLACEHOLDER = 'START TYPING...';
var NO_MATCH_TEXT = 'No Options';
var LookupSelect = function (_a) {
    var _b;
    var id = _a.id, label = _a.label, value = _a.value, options = _a.options, isLoading = _a.isLoading, isDisabled = _a.isDisabled, isSearchable = _a.isSearchable, isOptional = _a.isOptional, onChange = _a.onChange;
    var hasNoOptions = !isLoading && !isDisabled && options.length === 0;
    var handleChange = React.useCallback(function (event) { return onChange(event.target.value); }, [onChange]);
    var helperText = isLoading
        ? LOADING_HELPER_TEXT
        : hasNoOptions
            ? NO_OPTIONS_HELPER_TEXT
            : '';
    var captionNode = (React.createElement(Box, { component: "span" },
        label,
        isOptional ? (React.createElement(Box, { component: "span", sx: LOOKUP_OPTIONAL_MARK_SX },
            ' ',
            "(Optional)")) : (React.createElement(Box, { component: "span", sx: LOOKUP_REQUIRED_MARK_SX }, "*"))));
    var loaderNode = isLoading ? React.createElement(CircularProgress, { size: 14, sx: LOOKUP_LOADER_SX }) : undefined;
    if (isSearchable) {
        var selectedOption = (_b = options.find(function (option) { return String(option.value) === value; })) !== null && _b !== void 0 ? _b : null;
        return (React.createElement(Autocomplete, { id: id, fullWidth: true, size: "small", options: options, value: selectedOption, disabled: isDisabled || isLoading, getOptionLabel: function (option) { return option.label; }, isOptionEqualToValue: function (option, selected) {
                return String(option.value) === String(selected.value);
            }, onChange: function (_event, option) {
                return onChange(option ? String(option.value) : '');
            }, noOptionsText: NO_MATCH_TEXT, renderOption: function (optionProps, option) { return (React.createElement(MenuItem, __assign({}, optionProps, { key: String(option.value), sx: LOOKUP_MENU_ITEM_SX }), option.label)); }, renderInput: function (params) { return (React.createElement(MuiTextField, __assign({}, params, { name: id, label: captionNode, placeholder: SEARCH_PLACEHOLDER, helperText: helperText, sx: dynamicFieldSx, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                        loaderNode,
                        params.InputProps.endAdornment)) }) }))); } }));
    }
    return (React.createElement(MuiTextField, { select: true, fullWidth: true, size: "small", id: id, name: id, value: value, disabled: isDisabled || isLoading, onChange: handleChange, helperText: helperText, label: captionNode, sx: dynamicFieldSx, InputProps: { endAdornment: loaderNode }, SelectProps: LOOKUP_SELECT_PROPS },
        options.length === 0 && (React.createElement(MenuItem, { value: "", disabled: true }, "No Options")),
        options.map(function (option) { return (React.createElement(MenuItem, { key: String(option.value), value: String(option.value), sx: LOOKUP_MENU_ITEM_SX }, option.label)); })));
};
export default React.memo(LookupSelect);
